import api from './client';
import type { ConfigResponse } from '../types/config';
import { logError } from '../utils/clientLog';

export class ConfigService {
  /**
   * Busca a URL do Metabase configurada no backend
   */
  async getMetabaseUrl(): Promise<string> {
    try {
      const response = await api.get<ConfigResponse>('/config/metabase-url');
      
      if (response.data.success && response.data.data?.metabaseUrl) {
        return response.data.data.metabaseUrl;
      }
      
      throw new Error(response.data.message || 'URL do Metabase não encontrada');
    } catch (error: unknown) {
      logError('❌ Erro ao buscar URL do Metabase:', error);
      
      if (error && typeof error === 'object' && 'response' in error) {
        const axiosError = error as { response?: { data?: { message?: string } } };
        if (axiosError.response?.data?.message) {
          throw new Error(axiosError.response.data.message);
        }
      }
      
      throw new Error('Erro ao conectar com o servidor para buscar configuração do Metabase');
    }
  }
}

export const configService = new ConfigService();